import config from "../../../settings/config";

export async function fetchDeviceService(token) {

    try {
        const response = await fetch(`${config.app.host}/api/v1/device/list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            return null;
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при запросе устройств:", err);
        return null;
    } finally {

    }
}

export async function fetchCommandInDevice(token, sn, slaveId, action, value) {
    try {
        const response = await fetch(`${config.app.host}/api/v1/device/control`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                sn: sn,
                slaveId: slaveId,
                action: action,
                value: value,
            }),
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            return null;
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при отправке команды:", err);
        return null;
    } finally {

    }
}


